var exports = {
  "M": "logobarTopBorder__n4Pahw",
};

module.exports = exports;
